import FullWidthSlider from './aon_fullwidth_slider'
import FullWidthSliderSlide from './aon_fullwidth_slider_slide'

export default {
  aon_fullwidth_slider: FullWidthSlider,
  aon_fullwidth_slider_slide: FullWidthSliderSlide,
}